import styled from 'styled-components';

export const Header = styled.h1`
  padding: 16px;
  font-size: 60px;
  font-family: ${({ theme }) => theme.fonts.headerFont};
  color: ${({ theme }) => theme.colors.light};
  font-weight: normal;
  line-height: 1.2em;
  border: 2px solid #fff;
  display: flex;
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.6);
  text-shadow: 3px 3px 8px rgba(0, 0, 0, 0.6);
  text-align: center;
  @media (max-width: ${({ theme }) => theme.media.xs}) {
    font-size: 48px;
  }
`;
